// src/Components/AboutUs.js
import React, { useState, useEffect, useRef } from 'react';
import './AboutUs.css';
import heroImg from '../assets/for_the_future.png';
import textLLMImg from '../assets/aboutus_textLLM.png';
import ttiImg from '../assets/aboutus_tti.png';
import itvImg from '../assets/aboutus_itv.png';

export default function AboutUs() {
  const introRef = useRef();
  const featuresRef = useRef();
  const whyRef = useRef();

  const [introVisible, setIntroVisible] = useState(false);
  const [featuresVisible, setFeaturesVisible] = useState(false);
  const [whyVisible, setWhyVisible] = useState(false);

  useEffect(() => {
    const options = { threshold: 0.3 };
    const introObs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { setIntroVisible(true); introObs.disconnect(); }
    }, options);
    const featObs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { setFeaturesVisible(true); featObs.disconnect(); }
    }, options);
    const whyObs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { setWhyVisible(true); whyObs.disconnect(); }
    }, options);

    if (introRef.current)    introObs.observe(introRef.current);
    if (featuresRef.current) featObs.observe(featuresRef.current);
    if (whyRef.current)      whyObs.observe(whyRef.current);

    return () => {
      introObs.disconnect(); featObs.disconnect(); whyObs.disconnect();
    };
  }, []);

  const services = [
    {
      title: 'Customize & Craft AI Agents',
      desc: 'Intuitive workflows for model combination, fine-tuning, and custom data integration.',
      img: textLLMImg,
      anim: 'left'
    },
    {
      title: 'Buy, Sell & Trade AI Agents',
      desc: 'Open marketplace for creators to license, sell, or exchange AI agents securely.',
      img: ttiImg,
      anim: 'up'
    },
    {
      title: 'Future-Ready with Web3 Integration',
      desc: 'Tokenized licensing, governance tokens, and decentralized agent marketplaces.',
      img: itvImg,
      anim: 'right'
    },
  ];

  const whyPoints = [
    'Comprehensive Model Selection: Text LLMs, image, and video AI under one roof.',
    'Infinite Customization: Design agents to match any creative or business goal.',
    'Vibrant Community: Collaborate worldwide through sharing and open discussion.',
    'Monetization Opportunities: Flexible licensing and revenue models.',
    'Future-Proof Vision: Web3 integration for decentralized growth.',
  ];

  return (
    <div className="about-page">

      {/* Hero */}
      <section className="hero about-hero">
        <img src={heroImg} alt="About Hero" className="hero-bg" />
        <div className="hero-overlay" />
        <div className="hero-content about-hero-content">
          <h1>About ARCANES</h1>
          <p>Empowering AI Innovations Across Industries</p>
        </div>
      </section>

      {/* Introductory Section */}
      <section
        ref={introRef}
        className={`about-intro animate-up ${introVisible ? 'visible' : ''}`}
      >
        <h2>Welcome to ARCANES</h2>
        <p>
          ARCANES is the next-generation platform where imagination converges with cutting-edge AI. Our mission is to
          empower creators, innovators, and visionaries to conceptualize, build, and unleash AI agents that push the
          boundaries of what’s possible.
        </p>
        <h3>A Home for AI Agents of Every Kind</h3>
        <p>
          Whether you’re a researcher or enthusiast, ARCANES offers a unified AI ecosystem with intuitive tools and
          powerful backend infrastructure—everything you need in one seamless environment.
        </p>
      </section>

      {/* Features Grid */}
      <section
        ref={featuresRef}
        className="about-features-section"
      >
        <h2 className={`features-title animate-down ${featuresVisible ? 'visible' : ''}`}>What We Offer</h2>
        <div className="services-grid">
          {services.map((s, idx) => (
            <div
              key={idx}
              className={`service-card animate-${s.anim} ${featuresVisible ? 'visible' : ''}`}
            >
              <img src={s.img} alt={s.title} className="service-icon" />
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Why Choose ARCANES */}
      <section
        ref={whyRef}
        className={`about-why animate-up ${whyVisible ? 'visible' : ''}`}
      >
        <h2>Why Choose ARCANES?</h2>
        <ul className="why-list">
          {whyPoints.map((pt, idx) => (
            <li key={idx}>{pt}</li>
          ))}
        </ul>
      </section>

    </div>
  );
}










// // src/components/AboutUs.js


// import React, { useState, useEffect, useRef } from 'react';
// import './AboutUs.css';

// import agentsImg from '../assets/agents.png';
// import futureImg from '../assets/for_the_future.png';
// import textLLMImg from '../assets/aboutus_textLLM.png';
// import ttiImg from '../assets/aboutus_tti.png';
// import itvImg from '../assets/aboutus_itv.png';

// function AboutUs() {
//   const [stackVisible, setStackVisible] = useState(false);
//   const stackRef = useRef(null);

//   // IntersectionObserver to trigger stack animation
//   useEffect(() => {
//     const obs = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           setStackVisible(true);
//           obs.disconnect();
//         }
//       },
//       { threshold: 0.3 }
//     );
//     if (stackRef.current) obs.observe(stackRef.current);
//     return () => obs.disconnect();
//   }, []);

//   return (
//     <div className="aboutus-container">
//       <header className="aboutus-header">
//         <img src={agentsImg} alt="Agents" className="title-image title1" />
//         <img src={futureImg} alt="For the Future" className="title-image title2" />
//       </header>

//       <section className="aboutus-content">
//         <p>
//           Welcome to AI Depot, the next‑generation platform where imagination converges with cutting‑edge artificial intelligence. Our mission is to empower creators, innovators, and visionaries to conceptualize, build, and unleash AI agents that push the boundaries of what’s possible.
//         </p>

//         <hr />

//         <h2>A Home for AI Agents of Every Kind</h2>
//         <p>
//           At AI Depot, we believe in offering a comprehensive AI ecosystem in a single, streamlined environment. Whether you’re a researcher or an enthusiast, our platform supports you with user‑friendly tools and powerful back‑end infrastructure.
//         </p>

//         {/* Image stack replaces the old list */}
//         <div className="stack-container" ref={stackRef}>
//           <img
//             src={textLLMImg}
//             alt="Text LLMs"
//             className={`stack-image img1 ${stackVisible ? 'visible' : ''}`}
//           />
//           <img
//             src={ttiImg}
//             alt="Text-to-Image Models"
//             className={`stack-image img2 ${stackVisible ? 'visible' : ''}`}
//           />
//           <img
//             src={itvImg}
//             alt="Image-to-Video Models"
//             className={`stack-image img3 ${stackVisible ? 'visible' : ''}`}
//           />
//         </div>

//         <h2>Customize and Craft Your AI Agents</h2>
//         <p>
//           From the moment you register with AI Depot, you become both a creator and curator of next-generation AI technology. We provide intuitive workflows for:
//         </p>
//         <ol>
//           <li><strong>Agent Customization:</strong> Combine multiple models, fine-tune parameters, and integrate custom data or unique prompts to create AI agents tailored to your exact specifications.</li>
//           <li><strong>Ownership and Governance:</strong> Each AI agent you bring to life is unequivocally yours. You can choose to share it freely with the community or retain private access and control over future improvements.</li>
//           <li><strong>Collaboration and Sharing:</strong> Collaborate with fellow innovators by sharing your agent’s capabilities, architecture, and intended use-cases. Collect feedback, inspire others, and help drive the entire field forward.</li>
//         </ol>
//         <h2>Buy, Sell, and Trade AI Agents</h2>
//         <p>
//           At the heart of AI Depot is an open marketplace where creators can list their AI agents for sale or licensing:
//         </p>
//         <ul>
//           <li><strong>Flexible Monetization:</strong> Whether you want to license your agent under a subscription model, sell it outright, or trade functionalities with another creator, our platform offers multiple paths to monetization.</li>
//           <li><strong>Secure Transactions:</strong> We implement advanced security protocols and transparent smart contract frameworks—ensuring a safe, reliable trading environment for all parties.</li>
//           <li><strong>Community-Driven Quality:</strong> Agents that earn high user ratings or demonstrate exceptional performance can be featured, driving greater visibility and attracting potential buyers.</li>
//         </ul>
//         <h2>Future-Ready With Web3 Integration</h2>
//         <p>
//           Looking ahead, AI Depot is committed to embracing the decentralized, democratized future of Web3. In our upcoming expansion:
//         </p>
//         <ol>
//           <li><strong>Licensing and Tokenomics:</strong> We aim to tokenize the value of your AI agents, letting you define how ownership and usage rights are distributed via blockchain-based smart contracts.</li>
//           <li><strong>Governance:</strong> By introducing governance tokens, active community members can vote on platform-wide decisions, model curation, and feature rollouts—ensuring AI Depot evolves under a collective vision.</li>
//           <li><strong>Quality Assurance:</strong> Only AI agents that pass our rigorous vetting process will be available on our Web3 marketplace, guaranteeing that users encounter top-tier, responsibly-built solutions.</li>
//           <li><strong>Cross-Platform Interoperability:</strong> We’re building the framework for seamless integration with other Web3 platforms, opening doors to collaboration and co-innovation across various decentralized ecosystems.</li>
//         </ol>
//         <h2>Why Choose AI Depot?</h2>
//         <p>
//           <strong>Comprehensive Model Selection:</strong> Rarely do you find a platform that unites so many advanced models—text LLMs, text-to-image generators, and even image-to-video solutions—under one roof.
//         </p>
//         <p>
//           <strong>Infinite Customization:</strong> Our streamlined customization options let you design AI agents that perfectly match your creative or business objectives.
//         </p>
//         <p>
//           <strong>Vibrant Community:</strong> Join a global network of AI enthusiasts and experts who engage with each other through resource sharing, agent collaboration, and open discussions.
//         </p>
//         <p>
//           <strong>Monetization Opportunities:</strong> Our marketplace makes it simple to profit from your innovations, with flexible payment and licensing structures.
//         </p>
//         <p>
//           <strong>Future-Proof Vision:</strong> By bridging into Web3, we ensure your AI solutions remain at the forefront of emerging digital economies, offering you an ever-expanding universe of possibilities.
//         </p>
//         <hr />
//         <h2>Our Commitment to Ethical and Responsible AI</h2>
//         <p>
//           We understand the power that AI holds and are dedicated to ensuring its responsible use. With robust review processes, clear community guidelines, and ongoing research, we strive to create a safe and empowering ecosystem for all.
//         </p>
//         <p>
//           Embrace the transformative power of AI—become a creator, innovator, and entrepreneur at AI Depot, where the future of artificial intelligence is yours to shape.
//         </p>
//       </section>
//     </div>
//   );
// }

// export default AboutUs;
